import { useEffect } from "react";
import { STORAGE_KEYS, useStorage } from "src/hooks/useStorage";
import { useUser } from "src/hooks/useUser";

export const useClearForbiddenFlag = () => {
    const { data: user } = useUser();
    const [isForbidden, setIsForbidden] = useStorage(STORAGE_KEYS.IS_FORBIDDEN, false);

    useEffect(() => {
        if (user && isForbidden) {
            setIsForbidden(false);
        }
    }, [user, isForbidden, setIsForbidden]);
};
